import React, { CSSProperties, ReactNode } from 'react';
import {
  StyledContent,
  StyledDarkContent,
} from '@/components/MobileApproval/SubHeaderContent/styles';

type P = {
  id: number;
  title: ReactNode;
  clicked: boolean;
  handleClick(id: number): void;
  style?: CSSProperties;
  darkMode?: boolean;
};

const SubHeaderContent = ({
  id,
  title,
  clicked,
  handleClick,
  style,
  darkMode,
}: P) => {
  return darkMode ? (
    <StyledDarkContent
      type={'button'}
      key={`subHeader-${id}`}
      clicked={clicked}
      onClick={() => handleClick(id)}
      style={style}
    >
      {title}
    </StyledDarkContent>
  ) : (
    <StyledContent
      type={'button'}
      key={`subHeader-${id}`}
      clicked={clicked}
      onClick={() => handleClick(id)}
      style={style}
    >
      {title}
    </StyledContent>
  );
};
export default SubHeaderContent;
